import _ from 'lodash'

export const PageKey = {
  CASE: 'case',
  ASSIGNMENT: 'assignment',
  PRESENTATION: 'presentation',
  PRESENTATION_CASE: 'presentation_case',
  TRIAL_DETAIL: 'trial_detail'
}

export function getFilterValue(value) {
  return _.map(value, it => {
    if (it instanceof Object) {
      return it.value
    } else return it
  })
}
